import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from '../../config/app-settings';

const Dashboard = React.memo(() => {
    const context = useContext(AppSettings);
    const { first_name, last_name } = JSON.parse(localStorage.getItem('authUser') || '{}');
    const fullName = [first_name, last_name].filter(Boolean).join(' ') || 'there';

    useEffect(() => {
        context.setAppHeaderNone(false);
        context.setAppSidebarNone(false);
        context.setAppContentClass('');
        context.setAppThemePanal(true);

        return () => {
            context.setAppHeaderNone(true);
            context.setAppSidebarNone(true);
            context.setAppContentClass('p-0');
            context.setAppThemePanal(false);
        };
    }, [context]);

    const quickAccessItems = [
        {
            path: '/general-analytics',
            icon: 'fas fa-chart-bar',
            title: 'General Analytics',
            description: 'View overall analytics and statistics',
            show: true,
        },
        {
            path: '/campaigns-analytics',
            icon: 'fas fa-chart-pie',
            title: 'Campaigns Analytics',
            description: 'Analyze campaign performance',
            show: true,
        },
        {
            path: '/customer-dashboard',
            icon: 'fas fa-users',
            title: 'Customer Dashboard',
            description: 'Overview of all customers',
            show: true,
        },
        {
            path: '/iptv-analytics',
            icon: 'fas fa-user',
            title: 'IPTV Dashboard',
            description: 'Over all analytics',
            show: true,
        },
        {
            path: '/live-streaming-analytics',
            icon: 'fas fa-user',
            title: 'Live Streaming Analytics',
            description: 'Over all analytics',
            show: true,
        },
    ].filter(item => item.show);

    return (
        <div>
            <div className='mb-4'>
                <h1 className='page-header mb-1'>Welcome back, {fullName}!</h1>
                <p className='text-inverse text-opacity-50'>
                    Here's a quick overview of everything you have access to.
                </p>
            </div>
            <div className='row g-3'>
                {quickAccessItems.map(item => (
                    <div key={item.path} className='col-xl-3 col-lg-4 col-md-6'>
                        <Link to={item.path} style={{ textDecoration: 'none' }}>
                            <div
                                className='card h-100'
                                style={{ cursor: 'pointer', transition: 'transform 0.15s, box-shadow 0.15s' }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '';
                                }}
                            >
                                <div className='card-body d-flex align-items-center gap-3 p-3'>
                                    <div
                                        className='d-flex align-items-center justify-content-center rounded'
                                        style={{
                                            width: 46,
                                            height: 46,
                                            backgroundColor: 'rgba(var(--bs-theme-rgb), 0.15)',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <i className={`${item.icon} text-theme fs-5`}></i>
                                    </div>
                                    <div style={{ overflow: 'hidden' }}>
                                        <div className='fw-bold text-inverse text-truncate'>{item.title}</div>
                                        <div className='text-inverse text-opacity-50 small text-truncate'>
                                            {item.description}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
});

export default Dashboard;
